import React from "react";

import { Close as CloseIcon, Search as SearchIcon } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { graphql } from "@/gql";
import { useFragment } from "@/hooks/useFragment";
import { colors } from "@/theme/overrides/colors";

type SelectedClientViewProps = {
  id?: string | null;
  onClose: () => void;
};

const useStyles = makeStyles()({
  container: {
    height: 52,
    display: "flex",
    alignItems: "center",
    paddingLeft: 13,
    paddingRight: 13,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#D4DBE5",
  },
  user: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    marginLeft: 10,
  },
  avatar: {
    width: 30,
    height: 30,
    borderRadius: 50,
  },
  infoContainer: {
    marginLeft: 10,
  },
  name: {
    fontSize: 14,
    fontWeight: 600,
  },
  email: {
    fontSize: 12,
    color: colors.gray,
  },
  close: {
    cursor: "pointer",
  },
});

const selectedClientViewFragment = graphql(`
  fragment SelectedClientView on Client {
    id
    email
    profile {
      id
      fullName
      avatarUrl(variant: THUMB)
    }
  }
`);

const SelectedClientView: React.FC<SelectedClientViewProps> = ({
  id,
  onClose,
}) => {
  const { classes } = useStyles();
  const [client] = useFragment(selectedClientViewFragment, `Client:${id}`);
  return (
    <Box className={classes.container}>
      <SearchIcon htmlColor={colors.gray} />
      <Box className={classes.user}>
        <img
          className={classes.avatar}
          src={client?.profile?.avatarUrl ?? ""}
          alt="avatar"
        />
        <Box className={classes.infoContainer}>
          <Typography className={classes.name}>
            {client?.profile?.fullName}
          </Typography>
          <Typography className={classes.email}>{client?.email}</Typography>
        </Box>
      </Box>
      <CloseIcon className={classes.close} onClick={onClose} />
    </Box>
  );
};

export default SelectedClientView;
